let _ = require("lodash");

function invalid(v) {
  //无效的数据
  return v === undefined || v === "undefined" || v === null || (typeof v === "number" && isNaN(v));
}

function valid(v) {
  return !invalid(v);
}

const getId = (function () {
  let _currentId = 0;
  return () => {
    return ++_currentId;
  };
})();

const { deepEmpty, equals, dtoEmpty } = (function () {
  function deepEmpty(v) {
    let ty = type(v);
    if (ty === "array") {
      if (v.length === 0) return true;
      for (let i = 0; i < v.length; i++) {
        let t = v[i];
        let b = deepEmpty(t);
        if (!b) return false;
      }
      return true;
    }

    if (ty === "object") {
      if (dtoEmpty(v)) return true;
      for (let e in v) {
        let t = v[e];
        if (!deepEmpty(t)) return false;
      }
      return true;
    }

    if (ty === "function" || ty === "null") return true;
    return empty(v);
  }

  function equals(o0, o1, arg) {
    if (o0 === o1) return true;
    if (!arg) arg = {};
    let o0Type = type(o0);
    if (o0Type === "object") {
      return objectEquals(o0, o1, arg);
    }

    if (o0Type === "array") {
      return arrayEquals(o0, o1, arg);
    }

    if (arg.valueIgnoreCase) {
      return o0.toLowerCase() === o1.toLowerCase();
    }

    if (arg.strong) {
      //强类型对比
      return o0 === o1;
    }

    //默认不是强类型
    return o0 === o1; //这里不识别类型，也就是说1是等于'1'的
  }

  function objectEquals(o0, o1, arg) {
    if ((o0 && !o1) || (!o0 && o1)) return false;
    return objectEqualsAB(o0, o1, arg) && objectEqualsAB(o1, o0, arg);
  }

  function objectEqualsAB(o0, o1, arg) {
    for (var e in o0) {
      let left, right;
      if (arg.propertyIgnoreCase) {
        //忽略属性名大小写比较
        left = objGet(o0, e);
        right = objGet(o1, e);
      } else {
        left = o0[e];
        right = o1[e];
      }
      if (!equals(left, right, arg)) return false;
    }
    return true;
  }

  function arrayEquals(o0, o1, arg) {
    if ((o0 && !o1) || (!o0 && o1)) return false;
    if (o0.length !== o1.length) return false;
    for (let i = 0; i < o0.length; i++) {
      if (!equals(o0[i], o1[i], arg)) return false;
    }
    return true;
  }

  function objGet(o, p) {
    //不区分大小写的获取对象属性
    p = p.toLowerCase();
    for (let e in o) {
      if (o.hasOwnProperty(e) && e.toLowerCase() === p) {
        return o[e];
      }
    }
  }

  function objSet(o, p, v) {
    //不区分大小写的设置对象属性
    p = p.toLowerCase();
    for (let e in o) {
      if (o.hasOwnProperty(e) && e.toLowerCase() === p) {
        return (o[e] = v);
      }
    }
  }

  function dtoEmpty(v) {
    if (invalid(v)) return true;
    return v.__empty;
  }

  return { deepEmpty, equals, dtoEmpty };
})();

function empty(v) {
  if (invalid(v) || v === "") return true;
  if (dtoEmpty(v)) return true;
  let code = JSON.stringify(v);
  if (code === "{}" || code === "[]") return true;
  return false;
}

function arrayEquals(left, right, arg) {
  arg = arg || {};
  let { order, func } = arg;
  if (!func)
    func = function (v0, v1) {
      return v0 == v1;
    };
  if (left.length !== right.length) return;
  if (order) {
    for (let i = 0; i < left.length; i++) {
      if (!func(left[i], right[i])) return false;
    }
  } else {
    for (let i = 0; i < left.length; i++) {
      if (!contains(right, t => func(t, left[i]))) return false;
    }
  }
  return true;
}

function removeAt(l, p) {
  let le = l.length;
  if (p < 0 || p >= le) return;
  for (let i = p; i < le - 1; i++) l[i] = l[i + 1];
  return l.pop();
}

function type(o) {
  let ty = typeof o;
  if (ty === "object") {
    if (o == null) return "null";
    if (o.constructor === Array) return "array";
    if (o.constructor === Date) return "date";
    //if (isEvent(o)) return "event";
    if (o.constructor === Blob) return "blob";
    if (o.type && o.type.name) return o.type.name;
  }
  return ty;
}

function contains(l, f) {
  if (type(f) !== "function") {
    //传递的值，那么就直接对比
    let v = f;
    f = function (v1, i) {
      return v === v1;
    };
  }
  return !empty(_.find(l, f));
}

function indexOf(l, f) {
  for (let i = 0; i < l.length; i++) {
    let o = l[i];
    if (f(o, i)) {
      return i;
    }
  }
  return -1;
}

function bytesToAscii(bytes) {
  let s = "";
  for (var i = 0; i < bytes.length; i++) {
    s += String.fromCharCode(bytes[i]);
  }

  return s;
}

function min(l, f) {
  if (!l || l.length == 0) return null;
  var min, c;
  for (var i = 0; i < l.length; i++) {
    var o = l[i], v = f(o);
    if (i == 0) {
      c = v;
      min = o;
    } else {
      if (v < c) {
        c = v;
        min = o;
      }
    }
  }
  return min;
}

function max(l, f) {
  if (!l || l.length == 0) return null;
  var max, c;
  if (!f) f = (t) => t;
  for (let i = 0; i < l.length; i++) {
    let o = l[i], v = f(o);
    if (i == 0) {
      c = v;
      max = o;
    } else {
      if (v > c) {
        c = v;
        max = o;
      }
    }
  }
  return max;
}

function order(l, func, t) { //type:asc desc
  if (!t) t = "asc";
  var m = {};
  var ef = t === "asc" ? function (a, b) { return a < b; } : function (a, b) { return a > b; };
  for (var i = 0; i < l.length; i++) {
    for (var k = 0; k < l.length; k++) {
      if (ef(func(l[i]), func(l[k]))) {
        m = l[k];
        l[k] = l[i];
        l[i] = m;
      }
    }
  }
  return l;
}

function parseJSON(code) {
  if (!code) return;
  let obj = null;
  eval("obj=" + code + ";");
  return obj;
}

function stringifyJSON(obj) {
  return JSON.stringify(obj);
}

function clone(o) {
  let code = stringifyJSON(o);
  return parseJSON(code);
}

function remove(l, f)  {
  let index = indexOf(l, f);
  removeAt(l, index);
}

module.exports = { min, max, invalid, valid, getId, empty, deepEmpty, equals, dtoEmpty, arrayEquals, removeAt, remove, type, contains, clone, indexOf, bytesToAscii,order };
